var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 17,
    viewBox: "0 0 79 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 17,
    rx: 4,
    fill: "url(#paint0_linear_3820_5036)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3820_5036)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.84745,
    cy: 8.66825,
    r: 4.84745,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0307 13V4.27273H21.3034C21.9739 4.27273 22.5364 4.39773 22.9909 4.64773C23.4483 4.89773 23.7935 5.24148 24.0265 5.67898C24.2623 6.11364 24.3801 6.60795 24.3801 7.16193C24.3801 7.72159 24.2623 8.21875 24.0265 8.65341C23.7907 9.08807 23.4426 9.4304 22.9824 9.6804C22.5222 9.92756 21.9554 10.0511 21.2821 10.0511H19.1131V8.75142H21.0691C21.4611 8.75142 21.7821 8.68324 22.0321 8.54688C22.2821 8.41051 22.4668 8.22301 22.5861 7.98438C22.7083 7.74574 22.7694 7.47159 22.7694 7.16193C22.7694 6.85227 22.7083 6.57955 22.5861 6.34375C22.4668 6.10795 22.2807 5.92472 22.0279 5.79403C21.7779 5.66051 21.4554 5.59375 21.0605 5.59375H19.6117V13H18.0307ZM25.7534 13V4.27273H29.0261C29.6966 4.27273 30.2591 4.3892 30.7136 4.62216C31.171 4.85511 31.5162 5.18182 31.7491 5.60227C31.9849 6.01989 32.1028 6.5071 32.1028 7.06392C32.1028 7.62358 31.9835 8.10937 31.7449 8.52131C31.5091 8.9304 31.161 9.24716 30.7008 9.47159C30.2406 9.69318 29.6752 9.80398 29.0048 9.80398H26.6738V8.49148H28.7917C29.1838 8.49148 29.5048 8.4375 29.7548 8.32955C30.0048 8.21875 30.1895 8.05824 30.3088 7.84801C30.4309 7.63494 30.492 7.37358 30.492 7.06392C30.492 6.75426 30.4309 6.49006 30.3088 6.27131C30.1866 6.04972 30.0005 5.8821 29.7505 5.76847C29.5005 5.65199 29.1781 5.59375 28.7832 5.59375H27.3343V13H25.7534ZM30.2619 9.04545L32.4224 13H30.6582L28.536 9.04545H30.2619ZM33.5581 13V4.27273H39.2342V5.59801H35.139V7.96733H38.9402V9.29261H35.139V11.6747H39.2683V13H33.5581ZM40.8471 4.27273H42.7818L45.3727 10.5966H45.475L48.0659 4.27273H50.0005V13H48.4835V7.00426H48.4025L45.9906 12.9744H44.8571L42.4451 6.99148H42.3642V13H40.8471V4.27273ZM53.3031 4.27273V13H51.7221V4.27273H53.3031ZM60.5165 4.27273H62.0975V9.97443C62.0975 10.5994 61.9498 11.1491 61.6543 11.6236C61.3617 12.098 60.9498 12.4687 60.4185 12.7358C59.8873 13 59.2665 13.1321 58.5563 13.1321C57.8432 13.1321 57.2211 13 56.6898 12.7358C56.1586 12.4687 55.7466 12.098 55.454 11.6236C55.1614 11.1491 55.0151 10.5994 55.0151 9.97443V4.27273H56.5961V9.84233C56.5961 10.206 56.6756 10.5298 56.8347 10.8139C56.9966 11.098 57.2239 11.321 57.5165 11.483C57.8091 11.642 58.1557 11.7216 58.5563 11.7216C58.9569 11.7216 59.3034 11.642 59.5961 11.483C59.8915 11.321 60.1188 11.098 60.2779 10.8139C60.437 10.5298 60.5165 10.206 60.5165 9.84233V4.27273ZM63.8159 4.27273H65.7505L68.3414 10.5966H68.4437L71.0346 4.27273H72.9693V13H71.4522V7.00426H71.3713L68.9593 12.9744H67.8258L65.4139 6.99148H65.3329V13H63.8159V4.27273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35552 11.4546L4.80107 8.73428C4.69069 8.54112 4.87709 8.31374 5.08815 8.3841L5.69226 8.58547C5.8262 8.63011 5.9698 8.55129 6.00404 8.41432L6.32148 7.14455C6.36718 6.96178 6.59479 6.89874 6.728 7.03195L7.61963 7.92358C7.74267 8.04662 7.95143 8.00377 8.01605 7.84221L8.62399 6.32236C8.70525 6.11922 8.99281 6.11922 9.07407 6.32236L9.70107 7.88985C9.7603 8.03793 9.94394 8.08943 10.0715 7.99374L11.3697 7.0201C11.5295 6.90027 11.7575 7.01427 11.7575 7.214V8.33196C11.7575 8.49739 11.9196 8.61421 12.0765 8.5619L12.6099 8.3841C12.821 8.31374 13.0074 8.54112 12.897 8.73428L11.3425 11.4546C11.2994 11.5301 11.2191 11.5767 11.1321 11.5767H6.56596C6.47898 11.5767 6.39868 11.5301 6.35552 11.4546Z",
    fill: "#661961"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3820_5036",
    x: 2.06102,
    y: 1.88182,
    width: 72.8467,
    height: 13.5728,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.96949
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.308333 0 0 0 0 0.0244097 0 0 0 0 0.29123 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3820_5036"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3820_5036",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3820_5036",
    x1: 64.9556,
    y1: 15.8667,
    x2: 3.98427,
    y2: -22.6672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.486465,
    stopColor: "#590654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#783674"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/Premium.1a701eabc83b21455aa3ac5c34dfeb2f.svg";
export { ForwardRef as ReactComponent };